import { Grid, Typography } from '@mui/material';
import React from 'react';
import Service from '../../others/service/service';
import logo_emmenagement from '../../../assets/images/refonte/j_emmenage.png';
import logo_raccordement_ac from '../../../assets/images/refonte/je_fais_contrôler_mon_installation.png';
import logo_payment from '../../../assets/images/refonte/je_règle_ma_facture.png';
import './online-process.ui.scss';
import logo_meter_reading from '../../../assets/images/refonte/demarches-en-ligne.png';
import { env } from '../../../env';

/**
 * Composant pour les mentions légales.
 * @constructor
 */
export default function OnlineProcessUi() {
    // Création de la page
    // Pas besoin de vérification de connexion, d'appel, la page est en dure.
    const onlineProcess = 'online-process';
    return (
        <Grid className="containerOnlineProcess" container spacing={6}>
            <Grid item xs={12} sx={{ marginTop: '10px' }}>
                {/*titre*/}
                <Typography variant="h4">Démarches en ligne</Typography>
            </Grid>
            <Grid item xs={12}>
                {/*texte*/}
                <Typography variant="body1">Facilitez-vous la vie grâce à nos services en ligne :</Typography>
            </Grid>
            {/* Bouton pour un emménagement */}
            <Grid className="gridCard" item xs={12} md={6}>
                <Service
                    title="J'emménage"
                    href="/j-emmenage"
                    description={
                        <Typography
                            variant="body1"
                            color="text.primary"
                            sx={{ textAlign: 'center', fontSize: 'small', margin: '5px' }}
                        >
                            J'informe le gestionnaire de l'eau de ma commune. Il procédera au changement de titulaire de
                            l'abonnement ou à sa résiliation administrative.{' '}
                        </Typography>
                    }
                    img={logo_emmenagement}
                    styleName={onlineProcess}
                />
            </Grid>
            {/* Bouton pour le paiement d'une facture */}
            <Grid className="gridCard" item xs={12} md={6}>
                <Service
                    title="Je règle ma facture"
                    href="/paiement-facture"
                    description={
                        <Typography
                            variant="body1"
                            color="text.primary"
                            sx={{ textAlign: 'center', fontSize: 'small', margin: '5px' }}
                        >
                            Avec le paiement en ligne, plus de chèque à remplir, plus de timbre à payer !
                        </Typography>
                    }
                    img={logo_payment}
                    styleName={onlineProcess}
                />
            </Grid>
            {/* Bouton pour faire une relève de compteur */}
            <Grid className="gridCard" item xs={12} md={6}>
                <Service
                    title="Je relève l'index de mon compteur"
                    href="/releve-compteur"
                    description={
                        <Typography
                            variant="body1"
                            color="text.primary"
                            sx={{ textAlign: 'center', fontSize: 'small', margin: '5px' }}
                        >
                            En transmettant mon relevé en ligne, je n'envoie plus de carte d'auto-relevé et ne reçois
                            plus de facture estimée.
                        </Typography>
                    }
                    img={logo_meter_reading}
                    styleName={onlineProcess}
                />
            </Grid>
            {/* Bouton pour faire une demande de raccordement */}
            {env.REACT_APP_THEME === 'sddea' && (
                <Grid className="gridCard" item xs={12} md={6}>
                    <Service
                        title="Je fais contrôler mon raccordement à l'assainissement"
                        href="/demande-raccordement-ac"
                        description={
                            <Typography
                                variant="body1"
                                color="text.primary"
                                sx={{ textAlign: 'center', fontSize: 'small', margin: '5px' }}
                            >
                                Le contrôle de raccordement au réseau de collecte des eaux usées est obligatoire lors de
                                la création ou de la modification d'installations sanitaires.
                            </Typography>
                        }
                        img={logo_raccordement_ac}
                        styleName={onlineProcess}
                    />
                </Grid>
            )}
        </Grid>
    );
}
